import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withSagas } from 'decorators/Sagas';
import { decorateWith } from 'helpers/decorator';
import { isEmpty } from 'helpers/verify';
import { selectUserDetectedLocation } from 'redux/modules/locale';
import { searchLocationAutocomplete } from 'redux/saga/entities/bound';
import {
  selectInputLocation,
  selectInputSelection,
  selectPlaceQuery,
  setInputSelection,
} from './LocationInput.reducer';
import { loadDetectedLocation, loadPlace, queryPlaces, watchLocationInputSagas } from './LocationInput.saga';
import { LocationInput } from './LocationInput';

export const mapStateToProps = state => {
  const detectedLocation = selectUserDetectedLocation(state);
  const inputQuery = selectPlaceQuery(state);
  const predictionData = searchLocationAutocomplete.data(state, `locationInput_${inputQuery}`) || {};

  return {
    hasDetectedLocation: !isEmpty(detectedLocation),
    inputLocation: selectInputLocation(state),
    placeSuggestions: predictionData.predictions || [],
    selectedItem: selectInputSelection(state),
  };
};

export const mapDispatchToProps = {
  queryPlaces,
  loadPlace,
  loadDetectedLocation,
  setInputSelection,
};

export const LocationInputContainer = decorateWith(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withSagas({ watch: watchLocationInputSagas })
)(LocationInput);
